export const DEEPLINK_URL = 'airasia://snapandhotel';
export const SNAP = 'snap';
export const HOTEL = 'hotel';

const SNAP_ROUTE = {
  ROOT: `/${SNAP}`,
  FLIGHT_HOTEL_LIST: `/${SNAP}/hotels/list`,
  FLIGHT_LIST: `/${SNAP}/flights/list`,
  TRIP_DETAIL: `/${SNAP}/trip`,
  GUEST_DETAIL: `/${SNAP}/guest`,
  HOTEL_DETAIL: `/${SNAP}/hotel/:hotelId`,
  CHECKOUT: `/${SNAP}/checkout`,
};

export const ICON_RATES_AMENITIES = {
  1: 'WifiIcon',
  2: 'RestaurantIcon',
  3: 'LocalParkingIcon',
  20: 'WifiIcon',
  21: 'WifiIcon',
  22: 'RestaurantIcon',
  23: 'RestaurantIcon',
  24: 'RestaurantIcon',
  25: 'RestaurantIcon',
  26: 'RestaurantIcon',
  27: 'RestaurantIcon',
  28: 'RestaurantIcon',
  29: 'RestaurantIcon',
  30: 'RestaurantIcon',
  31: 'RestaurantIcon',
  32: 'RestaurantIcon',
  33: 'RestaurantIcon',
  34: 'LocalDrinkIcon',
  35: 'AirportShuttleIcon',
  36: 'AirportShuttleIcon',
  37: 'AirportShuttleIcon',
  38: 'RvHookupIcon',
  39: 'LocalCafeIcon',
  40: 'WineBottle', // static
  41: 'StarsIcon',
  42: 'AccessTimeIcon',
  43: 'AccessTimeIcon',
  44: 'AssistantIcon',
  45: 'AssistantIcon',
  46: 'WineBottle',
  47: 'AssistantIcon',
  48: 'StarsIcon',
  49: 'StarsIcon',
  50: 'StarsIcon',
  51: 'StarsIcon',
  52: 'TouchAppIcon',
  53: 'PlaylistAddCheckIcon',
  54: 'AssistantIcon',
  55: 'DirectionsBoat',
  56: 'DirectionsBoat',
  57: 'AssistantIcon',
  58: 'StarsIcon',
  59: 'AccessTimeIcon',
  60: 'AccessTimeIcon',
  61: 'AssistantIcon',
  62: 'Liquor', // not getting from MI
  63: 'LooksIcon',
  64: 'WifiIcon',
  65: 'RestaurantIcon',
  66: 'LocalParkingIcon',
  67: 'VideoLabelIcon',
  68: 'PlaylistAddCheckIcon',
  70: 'RestaurantIcon',
  71: 'RestaurantIcon',
  72: 'RestaurantIcon',
  73: 'RestaurantIcon',
  74: 'RestaurantIcon',
  75: 'SetMeal',
};

const HOTEL_ROUTE = {
  ROOT: `/${HOTEL}`,
  HOTEL_LIST: `/${HOTEL}/search`,
  HOTEL_DETAIL: `/${HOTEL}/:hotelId`,
  TRIP_DETAIL: `/${HOTEL}/:hotelId/:roomId/:rateId/:bedGroupId`,
  CHECKOUT: `/${HOTEL}/checkout`,
  CONFIRMATION: `/${HOTEL}/confirmation`,
  BOOKING_DETAIL: `/${HOTEL}/booking-detail`,
  ERROR: `/${HOTEL}/error`,
};

export const ROUTE = {
  ROOT: '/',
  MANAGE_BOOKING: '/manage-booking',
  CHECK_IN: '/check-in',
  SUPPORT: '/support',
  HOTEL: HOTEL_ROUTE,
  SNAP: SNAP_ROUTE,
};

export const Variant = {
  Error: 'error',
  Default: 'default',
  Info: 'info',
  Success: 'success',
  Hint: 'hint',
};

export const COUNTRY_CODE_DEFAULT = 'MY';

export const GuestType = {
  Adult: 'adults',
  Children: 'children',
  Infants: 'infants',
};

export const EMPTY_STATE = {
  EMPTY_HOTEL_LIST: 'empty_hotel_list',
  EMPTY_FLIGHT_HOTEL_SNAP: 'empty_flight_hotel_snap',
  EMPTY_HOTEL_ROOM_LIST: 'empty_hotel_room_list',
  EMPTY_BROWSER_HISTORY: 'empty_browser_history',
  EMPTY_HOTEL_LIST_ON_FILTER: 'empty_hotel_list_on_filter',
};

export const LOAD_MORE_THRESHOLD = 5;

export const DEFAULT_LOCALE = 'defaultLocale';
export const UHF_LOCALE_NAME = 'uhfLocale';
export const PROMOTION_FILTER = 'promotionFilter';

export const crossSellBannerData = {
  percentageOff: '55% OFF',
  bannerMsg: 'Incredible prices! Save up to 55% OFF for selected hotel stays',
  payNowMsg: 'Pay now and save 20% with code',
  tagMsg: 'AASTAY20',
  toggleMsg: 'Show available hotels',
  promoMsg: '20% off with promo code AASTAY20 ',
  comboSavingMsg: 'Additional savings up to 55% for selected hotels',
  discount: '55%',
  promo: 'AASTAY20',
  flyerDiscount: 'Flyer discount',
  exlusiveMsg: 'Exclusive deals for you ✨',
  isToggleEnable: true,
  handleToggle: () => {},
  flyerDiscountImg:
    'https://storage.googleapis.com/static.stgairasia.com/hotels/cross-sell-banner/flyer-discount.svg',
};

export const bannersData = {
  showVoucherBanner: false,
  enableVoucherBanner: false,
  enablePromoBanner: false,
  enableFetchUserSubscription: false,
  enableCrossSellToggleBanner: false,
  validSSO: false,
  isBannerImageInvalid: false,
  ENV_TYPE: 'https://static.stgairasia.com',
  bannerCountryCode: 'in',
  filter: {
    languageId: 'en-gb',
    currency: 'IDR',
  },
  isMobileView: false,
  appEnabledTheme: 'AIRASIA_MOVE',
  handleBannerError: () => {},
  showBigPayCard: false,
  isBigPayCardPromoEnabled: false,
  bigPayCardLabel: 'Get extra AirAsia points by using your BigPay card',
  voucherMessage:
    'Apply promo code “SUPERTRAVEL” during payment to get RM75 off',
  hotelNotFoundMsg:
    "Hotel not found! Let's show you other hotels worth exploring",
};

export const THEME = 'AIRASIA_MOVE';
export const SHORT_DATE_FORMAT_YEAR = 'ccc, dd LLL yyyy';
